<template>
  <div>

    <head>

      <meta charset="utf-8" />
      <title>CBHI | Community-Based Health Insurance</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0">
      <meta content="Keep your finances and membership up to date" name="description" />
      <meta content="Kelvin Njuguna Ndungu" name="author" />
      <!-- App favicon -->
      <link rel="shortcut icon" href="assets/images/favicon.svg">

      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css" />
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css" />

      <!-- Bootstrap select styling -->
      <link rel="stylesheet"
            href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css">

      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css" />
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css" />


    </head>

    <body data-sidebar="dark">


    <div>
    <div id="layout-wrapper">
      <NavigationBar/>

      <div class="main-content">
        <div class="page-content">
          <div class="container-fluid">
            <!-- Page Title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">Cash Collection Management</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="javascript: void(0);">Finance</a></li>
                      <li class="breadcrumb-item active">Cash Collection</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Summary Cards -->
            <div class="row">
              <div class="col-xl-3 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Today's Collections</p>
                        <h4 class="mb-0">ETB {{ formatCurrency(summary.todayAmount) }}</h4>
                        <small class="text-muted">{{ summary.todayTransactions }} transactions</small>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-primary">
                          <span class="avatar-title">
                            <i class="bx bx-money font-size-16"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Pending Submission</p>
                        <h4 class="mb-0">ETB {{ formatCurrency(summary.pendingAmount) }}</h4>
                        <small class="text-muted">{{ summary.pendingReports }} reports</small>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-warning">
                          <span class="avatar-title">
                            <i class="bx bx-hourglass font-size-16"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">This Month</p>
                        <h4 class="mb-0">ETB {{ formatCurrency(summary.monthAmount) }}</h4>
                        <small class="text-muted">{{ summary.monthTransactions }} transactions</small>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle bg-success">
                          <span class="avatar-title">
                            <i class="bx bx-calendar font-size-16"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-3 col-md-6">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex">
                      <div class="flex-1 overflow-hidden">
                        <p class="text-truncate font-size-14 mb-2">Variance Amount</p>
                        <h4 class="mb-0" :class="summary.varianceAmount >= 0 ? 'text-success' : 'text-danger'">
                          ETB {{ formatCurrency(Math.abs(summary.varianceAmount)) }}
                        </h4>
                        <small class="text-muted">{{ summary.varianceAmount >= 0 ? 'Overage' : 'Shortage' }}</small>
                      </div>
                      <div class="flex-shrink-0 align-self-center">
                        <div class="mini-stat-icon avatar-sm rounded-circle" :class="summary.varianceAmount >= 0 ? 'bg-success' : 'bg-danger'">
                          <span class="avatar-title">
                            <i class="bx bx-trending-up font-size-16" v-if="summary.varianceAmount >= 0"></i>
                            <i class="bx bx-trending-down font-size-16" v-else></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Quick Actions -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title">Quick Actions</h4>
                      <div class="d-flex gap-2">
                        <button class="btn btn-primary btn-sm" @click="generateTodayReport">
                          <i class="bx bx-plus me-1"></i>Generate Today's Report
                        </button>
                        <button class="btn btn-outline-info btn-sm" @click="refreshData">
                          <i class="bx bx-refresh me-1"></i>Refresh
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <!-- Filters -->
                    <div class="row mb-4">
                      <div class="col-md-3">
                        <label class="form-label">Date Range</label>
                        <select v-model="filters.dateRange" class="form-select" @change="applyFilters">
                          <option value="today">Today</option>
                          <option value="yesterday">Yesterday</option>
                          <option value="this_week">This Week</option>
                          <option value="this_month">This Month</option>
                          <option value="custom">Custom Range</option>
                        </select>
                      </div>
                      <div class="col-md-3" v-if="filters.dateRange === 'custom'">
                        <label class="form-label">From Date</label>
                        <input type="date" v-model="filters.fromDate" class="form-control" @change="applyFilters">
                      </div>
                      <div class="col-md-3" v-if="filters.dateRange === 'custom'">
                        <label class="form-label">To Date</label>
                        <input type="date" v-model="filters.toDate" class="form-control" @change="applyFilters">
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">Status</label>
                        <select v-model="filters.status" class="form-select" @change="applyFilters">
                          <option value="">All Status</option>
                          <option value="pending">Pending</option>
                          <option value="submitted">Submitted</option>
                          <option value="reconciled">Reconciled</option>
                          <option value="disputed">Disputed</option>
                        </select>
                      </div>
                      <div class="col-md-3">
                        <label class="form-label">Collector</label>
                        <select v-model="filters.collectorId" class="form-select" @change="applyFilters">
                          <option value="">All Collectors</option>
                          <option v-for="collector in collectors" :key="collector.id" :value="collector.id">
                            {{ collector.name }}
                          </option>
                        </select>
                      </div>
                    </div>

                    <!-- Reports Table -->
                    <div class="table-responsive">
                      <table class="table table-hover align-middle">
                        <thead class="table-light">
                        <tr>
                          <th>Report Reference</th>
                          <th>Collector</th>
                          <th>Collection Date</th>
                          <th>Transactions</th>
                          <th>Expected Amount</th>
                          <th>Submitted Amount</th>
                          <th>Variance</th>
                          <th>Status</th>
                          <th class="text-center">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading">
                          <td colspan="9" class="text-center py-5">
                            <div class="spinner-border text-primary" role="status">
                              <span class="visually-hidden">Loading...</span>
                            </div>
                          </td>
                        </tr>
                        <tr v-else-if="reports.length === 0">
                          <td colspan="9" class="text-center py-5 text-muted">
                            <i class="bx bx-folder-open display-4 mb-3"></i>
                            <p>No cash collection reports found</p>
                          </td>
                        </tr>
                        <tr v-else v-for="report in reports" :key="report.report_id">
                          <td>
                            <strong>{{ report.report_reference }}</strong>
                            <br>
                            <small class="text-muted">{{ report.collection_point }}</small>
                          </td>
                          <td>{{ report.collector_name }}</td>
                          <td>{{ formatDate(report.collection_date) }}</td>
                          <td>
                            <strong>{{ report.total_transactions }}</strong>
                            <small class="text-muted d-block">transactions</small>
                          </td>
                          <td>
                            <strong>ETB {{ formatCurrency(report.total_amount_collected) }}</strong>
                          </td>
                          <td>
                            <strong v-if="report.amount_submitted > 0">ETB {{ formatCurrency(report.amount_submitted) }}</strong>
                            <span v-else class="text-muted">-</span>
                          </td>
                          <td>
                              <span v-if="report.variance_amount !== 0"
                                    :class="report.variance_amount >= 0 ? 'text-success' : 'text-danger'">
                                {{ report.variance_amount >= 0 ? '+' : '' }}ETB {{ formatCurrency(report.variance_amount) }}
                              </span>
                            <span v-else class="text-success">Exact</span>
                          </td>
                          <td>
                              <span class="badge" :class="getStatusClass(report.status)">
                                {{ report.status.toUpperCase() }}
                              </span>
                          </td>
                          <td class="text-center">
                            <div class="btn-group" role="group">
                              <button class="btn btn-outline-primary btn-sm"
                                      title="View Details"
                                      @click="viewReport(report)">
                                <i class="bx bx-show"></i>
                              </button>
                              <button v-if="report.status === 'pending'"
                                      class="btn btn-outline-success btn-sm"
                                      title="Submit Collection"
                                      @click="submitCollection(report)">
                                <i class="bx bx-upload"></i>
                              </button>
                              <button v-if="report.status === 'submitted'"
                                      class="btn btn-outline-info btn-sm"
                                      title="Reconcile"
                                      @click="reconcileCollection(report)">
                                <i class="bx bx-check-circle"></i>
                              </button>
                              <button class="btn btn-outline-secondary btn-sm"
                                      title="Download Report"
                                      @click="downloadReport(report)">
                                <i class="bx bx-download"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>

                    <!-- Pagination -->
                    <div class="row mt-3" v-if="pagination.total > 0">
                      <div class="col-sm-6">
                        <div class="dataTables_info">
                          Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
                        </div>
                      </div>
                      <div class="col-sm-6">
                        <div class="dataTables_paginate float-end">
                          <button class="btn btn-sm btn-outline-secondary me-1"
                                  :disabled="pagination.current_page <= 1"
                                  @click="changePage(pagination.current_page - 1)">
                            Previous
                          </button>
                          <button class="btn btn-sm btn-outline-secondary"
                                  :disabled="pagination.current_page >= pagination.last_page"
                                  @click="changePage(pagination.current_page + 1)">
                            Next
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end d-sm-block">
                  Ministry of Health - Ethiopia
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>

    <!-- Modals -->
    <ReportDetailsModal
        ref="reportDetailsModal"
        @report-updated="handleReportUpdated"
    />

    <SubmissionModal
        ref="submissionModal"
        @collection-submitted="handleCollectionSubmitted"
    />

    <ReconciliationModal
        ref="reconciliationModal"
        @collection-reconciled="handleCollectionReconciled"
    />

    <!-- Alerts -->
    <div v-if="alert.show" :class="'alert alert-' + alert.type + ' alert-dismissible'" role="alert">
      {{ alert.message }}
      <button type="button" class="btn-close" @click="clearAlert"></button>
    </div>

    <div class="rightbar-overlay"></div>
  </div>


    </body>

  </div>



</template>

<script>
/* eslint-disable */
import NavigationBar from "@/components/Navigation.vue";
import ReportDetailsModal from "@/components/cbhi-finance/modals/ReportDetailsModal.vue";
import SubmissionModal from "@/components/cbhi-finance/modals/SubmissionModal.vue";
import ReconciliationModal from "@/components/cbhi-finance/modals/ReconciliationModal.vue";
import { authUrl, executeJson } from "@/api";
import router from "@/router";

export default {
  name: "CashCollectionDashboard",
  components: {
    NavigationBar,
    ReportDetailsModal,
    SubmissionModal,
    ReconciliationModal
  },
  data() {
    return {
      loading: false,
      reports: [],
      collectors: [],
      summary: {
        todayAmount: 0,
        todayTransactions: 0,
        pendingAmount: 0,
        pendingReports: 0,
        monthAmount: 0,
        monthTransactions: 0,
        varianceAmount: 0
      },
      filters: {
        dateRange: 'today',
        fromDate: '',
        toDate: '',
        status: '',
        collectorId: ''
      },
      pagination: {
        current_page: 1,
        last_page: 1,
        total: 0,
        from: 0,
        to: 0,
        per_page: 20
      },
      alert: {
        show: false,
        type: 'success',
        message: ''
      }
    };
  },

  mounted() {
    this.checkAuth();
    this.initializeDates();
    this.loadCollectors();
    this.loadSummary();
    this.loadReports();
  },

  methods: {
    checkAuth() {
      const token = localStorage.getItem("authToken");
      if (!token) {
        router.push('/login');
      }
    },

    initializeDates() {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      this.filters.fromDate = today.toISOString().split('T')[0];
      this.filters.toDate = today.toISOString().split('T')[0];
    },

    async loadCollectors() {
      try {
        const data = { "function": "getCashCollectors" };
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.collectors = res.data.data.collectors || [];
        }
      } catch (e) {
        console.error("Failed to load collectors:", e);
      }
    },

    async loadSummary() {
      try {
        const data = {
          "function": "getCashCollectionSummary",
          "dateRange": this.getDateRangeForAPI()
        };
        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.summary = res.data.data.summary || this.summary;
        }
      } catch (e) {
        console.error("Failed to load summary:", e);
      }
    },

    async loadReports(page = 1) {
      this.loading = true;

      try {
        const data = {
          "function": "getCashCollectionReports",
          "dateRange": this.getDateRangeForAPI(),
          "status": this.filters.status,
          "collectorId": this.filters.collectorId,
          "page": page,
          "limit": this.pagination.per_page
        };

        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.reports = res.data.data.reports || [];
          this.pagination = res.data.data.pagination || this.pagination;
        }
      } catch (e) {
        console.error("Failed to load reports:", e);
        this.showAlert('danger', 'Failed to load cash collection reports');
      } finally {
        this.loading = false;
      }
    },

    getDateRangeForAPI() {
      const today = new Date();
      let fromDate, toDate;

      switch (this.filters.dateRange) {
        case 'today':
          fromDate = toDate = today.toISOString().split('T')[0];
          break;
        case 'yesterday':
          const yesterday = new Date(today);
          yesterday.setDate(yesterday.getDate() - 1);
          fromDate = toDate = yesterday.toISOString().split('T')[0];
          break;
        case 'this_week':
          const startOfWeek = new Date(today);
          startOfWeek.setDate(today.getDate() - today.getDay());
          fromDate = startOfWeek.toISOString().split('T')[0];
          toDate = today.toISOString().split('T')[0];
          break;
        case 'this_month':
          const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
          fromDate = startOfMonth.toISOString().split('T')[0];
          toDate = today.toISOString().split('T')[0];
          break;
        case 'custom':
          fromDate = this.filters.fromDate;
          toDate = this.filters.toDate;
          break;
        default:
          fromDate = toDate = today.toISOString().split('T')[0];
      }

      return { fromDate, toDate };
    },

    async generateTodayReport() {
      try {
        const data = {
          "function": "generateCashCollectionReport",
          "collectionDate": new Date().toISOString().split('T')[0],
          "collectorId": localStorage.getItem("userId") || 1,
          "collectionPoint": sessionStorage.getItem("hospitalName") || "Main Office"
        };

        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          this.showAlert('success', 'Cash collection report generated successfully');
          this.loadReports();
          this.loadSummary();
        } else {
          this.showAlert('danger', res.data.message || 'Failed to generate report');
        }
      } catch (e) {
        this.showAlert('danger', 'Error generating cash collection report');
      }
    },

    viewReport(report) {
      this.$refs.reportDetailsModal.openModal(report);
    },

    submitCollection(report) {
      this.$refs.submissionModal.openModal(report);
    },

    reconcileCollection(report) {
      this.$refs.reconciliationModal.openModal(report);
    },

    async downloadReport(report) {
      try {
        const data = {
          "function": "downloadCashCollectionReport",
          "reportId": report.report_id
        };

        const res = await executeJson(data, authUrl);

        if (res.data.success) {
          // Generate and download PDF report
          this.generatePDFReport(report, res.data.data.reportDetails);
        }
      } catch (e) {
        this.showAlert('danger', 'Error downloading report');
      }
    },

    generatePDFReport(report, details) {
      // Simple implementation - in production, use jsPDF or similar
      const reportContent = this.formatReportForPrint(report, details);
      const printWindow = window.open('', '_blank');
      printWindow.document.write(reportContent);
      printWindow.document.close();
      printWindow.print();
    },

    formatReportForPrint(report, details) {
      return `
        <!DOCTYPE html>
        <html>
        <head>
          <title>Cash Collection Report - ${report.report_reference}</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            .header { text-align: center; margin-bottom: 30px; }
            .summary { background: #f8f9fa; padding: 15px; margin: 20px 0; }
            .table { width: 100%; border-collapse: collapse; margin: 20px 0; }
            .table th, .table td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            .table th { background-color: #f8f9fa; }
          </style>
        </head>
        <body>
          <div class="header">
            <h2>CBHI Cash Collection Report</h2>
            <h3>${report.report_reference}</h3>
            <p>Collection Date: ${this.formatDate(report.collection_date)}</p>
          </div>

          <div class="summary">
            <p><strong>Collector:</strong> ${report.collector_name}</p>
            <p><strong>Collection Point:</strong> ${report.collection_point}</p>
            <p><strong>Total Transactions:</strong> ${report.total_transactions}</p>
            <p><strong>Total Amount Collected:</strong> ETB ${this.formatCurrency(report.total_amount_collected)}</p>
            <p><strong>Amount Submitted:</strong> ETB ${this.formatCurrency(report.amount_submitted)}</p>
            <p><strong>Variance:</strong> ETB ${this.formatCurrency(report.variance_amount)}</p>
          </div>

          <!-- Transaction details would be added here -->
        </body>
        </html>
      `;
    },

    applyFilters() {
      this.pagination.current_page = 1;
      this.loadReports();
      this.loadSummary();
    },

    changePage(page) {
      if (page >= 1 && page <= this.pagination.last_page) {
        this.pagination.current_page = page;
        this.loadReports(page);
      }
    },

    refreshData() {
      this.loadSummary();
      this.loadReports();
    },

    handleReportUpdated() {
      this.loadReports();
      this.loadSummary();
    },

    handleCollectionSubmitted(data) {
      this.showAlert('success', data.message || 'Collection submitted successfully');
      this.loadReports();
      this.loadSummary();
    },

    handleCollectionReconciled(data) {
      this.showAlert('success', data.message || 'Collection reconciled successfully');
      this.loadReports();
      this.loadSummary();
    },

    getStatusClass(status) {
      const classes = {
        'pending': 'bg-warning',
        'submitted': 'bg-info',
        'reconciled': 'bg-success',
        'disputed': 'bg-danger'
      };
      return classes[status] || 'bg-secondary';
    },

    formatDate(dateString) {
      if (!dateString) return '-';
      return new Date(dateString).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    },

    formatCurrency(amount) {
      return new Intl.NumberFormat().format(amount || 0);
    },

    showAlert(type, message) {
      this.alert = { show: true, type, message };
      setTimeout(() => this.clearAlert(), 5000);
    },

    clearAlert() {
      this.alert.show = false;
    }
  }
};
</script>

<style scoped>
.mini-stat-icon {
  width: 60px;
  height: 60px;
}

.avatar-title {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.btn-group {
  display: flex;
  gap: 0.25rem;
}

.table th {
  font-weight: 600;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.5px;
}

.badge {
  font-size: 0.75rem;
  padding: 0.35rem 0.65rem;
}

.alert {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 1050;
  min-width: 300px;
}

.card {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
</style>